var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form-item',{attrs:{"label":_vm.field.name}},[_c('a-input-number',{attrs:{"placeholder":"Nhập số","value":_vm.value},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }